<script setup lang="ts">
import { CULTURE } from '@/composables/helpers'
import t from '@/i18n/translations'
import { computed } from 'vue'

const props = defineProps<{
  emptyCard: boolean
  formSubmitting: boolean
}>()

const formSub = computed(() => props.formSubmitting)

const eCard = computed(() => props.emptyCard)
</script>

<template>
  <div class="fixed bottom-3 left-0 right-0 z-10 w-full">
    <div class="container mx-auto py-2">
      <div class="md:px-11">
        <div class="pui-submit-button flex flex-row items-center px-2.5 text-white">
          <div class="w-full">
            <button
              v-if="!eCard"
              type="submit"
              :disabled="formSub"
              class="myEnquiryButton flex w-full items-center justify-center rounded bg-primary py-1.5 text-center text-[var(--p-text-color)]"
              @click="$window.siteEvent?.('button', 'enquiry-submit', '')"
            >
              {{ t(`${CULTURE}.enquirybar.enquiryButton`) }}
            </button>
            <button v-else type="submit" disabled class="bg-secondary whitespace-nowrap rounded border border-primary px-2 py-1 text-[var(--p-text-color)]">
              {{ t(`${CULTURE}.enquiry.form.anagraph.errors.required.emptyCard`) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
